import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Client-side route changes don't reload the page, so the browser keeps
// whatever scroll position the previous page was at — e.g. clicking a CTA
// on the homepage while scrolled halfway down lands on /bob still scrolled
// halfway down instead of at its hero. This resets scroll to the top on
// every pathname change.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
